import Index from '@/pages/Admin/Index'
import New from '@/pages/Admin/New'
import Files from '@/pages/Admin/Files'
import Metadata from '@/pages/Admin/Metadata'
import Frozen from '@/pages/Admin/Error'
import Success from '@/pages/Admin/Success'
import Decline from '@/pages/Admin/Decline'

export default {
  name: 'Index',
  path: '/admin',
  component: Index,
  children: [
    {
      path: 'new',
      name: 'New',
      component: New
    },
    {
      path: 'view',
      name: 'Files',
      component: Files
    },
    {
      path: 'frozen',
      name: 'Frozen',
      component: Frozen
    },
    {
      path: 'Success',
      name: 'Success',
      component: Success
    },
    {
      path: 'Decline',
      name: 'Decline',
      component: Decline
    },
    {
      path: 'metadata',
      name: 'Metadata',
      component: Metadata
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/admin.js